import './lib/ofi.min';
import './lib/inview.min';
import {
  hoverFunc
} from './common/_hover';
import {
  windowHeight
} from './common/_resize';
import {
  loadingFunc,
  topAnimaFunc,
  weekAnimeFunc,
  slideFunc,
} from './common/_animation';
import {
  LiffStart,
} from './common/_liff';
import {
  LiffAwsStart,
} from './common/_liff-aws';

//* -------------------------------------------------------------------
//通常実行
//------------------------------------------------------------------ */
let setTimer = false;
let loading = $('#loading');

// $(document).ready(function(){
//   $('html,body').animate({ scrollTop: 0 }, '1');
// });
loadingFunc();

// ロード時
$(window).on('load', function () {
  hoverFunc();
  windowHeight();
  LiffStart();
  //LiffAwsStart();
  topAnimaFunc();
  weekAnimeFunc();
  slideFunc();
});

// リサイズ時
$(window).on('resize', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {
  }, 300);
});

///* ------------------------------------------------------------------
//ユーザーエージェント判別実行(uaFlag：1→スマホ&タブレット・2→IE・3→その他PC)
//------------------------------------------------------------------ */
var uaFlag = 0;
if ((
    navigator.userAgent.indexOf('iPhone') > 0) ||
  (navigator.userAgent.indexOf('iPod') > 0) ||
  (navigator.userAgent.indexOf('iPad') > 0) ||
  (navigator.userAgent.indexOf('Android') > 0) ||
  (navigator.userAgent.indexOf('BlackBerry') > 0) ||
  (navigator.userAgent.indexOf('PlayBook') > 0) ||
  (navigator.userAgent.indexOf('Kindle') > 0) ||
  (navigator.userAgent.indexOf('Silk') > 0) ||
  (navigator.userAgent.indexOf('Windows Phone') > 0) ||
  (navigator.userAgent.indexOf('Nokia') > 0)
) {
  // スマホ・タブレット時の処理
  uaFlag = 1;
} else {
  // PC時の処理
  uaFlag = 3;
}

/* --------------------------------------------------------------------
IEだけの時
-------------------------------------------------------------------- */
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {

}